import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';

const Tooltip = React.forwardRef(function Tooltip(props, ref) {
    const {className, tip, children, id, ...rest} = props;
    const tipId = id || uuid();
    const baseProps = {
        id: tipId,
        className: classnames('tooltip', className),
        place: 'top',
        type: 'light',
        effect: 'solid',
        html: true
    };
    const extendedProps = {...baseProps, ...rest};
    const childrenProps = { 
        'data-for':  tipId,
        'data-tip': `<span class="typo typo--caption typo--dark">${tip}</span>`,
        'data-html': true,
        ref
    };
    const content = React.cloneElement(children,childrenProps);
    return (
        <>
            {content}
            <ReactTooltip {...extendedProps} />
        </>
    );
});

Tooltip.propTypes = {
    tip: PropTypes.string,
}
Tooltip.defaultProps = {
    tip: null,
};

export default Tooltip;
